import { UserType } from '@kijiji/generated/graphql-types'

/**
 * Determines if the given user type corresponds to a non-passenger vehicle (NPV) dealer.
 *
 * Specifically, it checks if the user type is one of the following dealer types:
 * - `UserType.Dealer`
 * - `UserType.HeDealer` (heavy equipment dealer)
 * - `UserType.RvDealer` (recreational vehicle dealer)
 *
 * @param userType - The user type to check.
 * @returns {boolean} True if the user type is a non-passenger vehicle dealer, false otherwise.
 */
export const isNpvDealer = (userType: UserType): boolean => {
  return (
    userType === UserType.Dealer || userType === UserType.HeDealer || userType === UserType.RvDealer
  )
}
